import { Action } from 'redux';
export const GET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS =
  'driver-home-page/GET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS';
export const SET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS =
  'driver-home-page/SET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS';
export const UPDATE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS =
  'driver-home-page/UPDATE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS';
export const DELETE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS =
  'driver-home-page/DELETE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS';
/**
 * Get home page contents
 */

export const getDriverHomepageWithoutSessionContents = (data: any): GetDriverHomepageWithoutSessionContentsAction => ({
  type: GET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS,
  payload: data,
});

export const setDriverHomepageWithoutSessionContents = (data: any) => ({
  type: SET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS,
  payload: data,
});

export const updateDriverHomepageWithoutSessionContents = (data: any) => {
  return {
    type: UPDATE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS,
    payload: data,
  };
};

export const deleteDriverHomepageWithoutSessionContents = (data: any) => {
  return {
    type: DELETE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS,
    payload: data,
  };
};

export interface GetDriverHomepageWithoutSessionContentsAction extends Action<
  typeof GET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS
> {
  payload: any;
}

export interface SetDriverHomepageWithoutSessionContentsAction extends Action<
  typeof SET_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS
> {
  payload: any;
}

export interface UpdateDriverHomepageWithoutSessionContentsAction extends Action<
  typeof UPDATE_DRIVER_HOME_PAGE_WITHOUT_SESSION_CONTENTS
> {
  payload: any;
}

export type DriverHomepageWithoutSessionAction =
  | GetDriverHomepageWithoutSessionContentsAction
  | SetDriverHomepageWithoutSessionContentsAction
  | UpdateDriverHomepageWithoutSessionContentsAction;
